import {AxiosResponse} from "axios";
import {GridPaginationModel} from "@mui/x-data-grid";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SBT_TEMPLATES_QUERY_KEY} from "../queryKeys";
import {SbtTemplatesPage} from "./types";

type Variables = {
  paginationModel: GridPaginationModel;
  search: string;
};

const getSbtTemplates = async (variables: Variables): Promise<SbtTemplatesPage> => {
  const response = await axiosReachInstance.get<SbtTemplatesPage, AxiosResponse<SbtTemplatesPage>>("/sbt-templates", {
    params: {
      page: variables.paginationModel.page + 1,
      size: variables.paginationModel.pageSize,
      search: variables.search,
    },
  });
  return response.data;
};

export const useGetSbtTemplates = (
  variables: Variables,
  options?: BaseQueryOptions<SbtTemplatesPage, Variables>
): BaseUseQueryResult<SbtTemplatesPage> => {
  const paramsKey = JSON.stringify(variables);
  return useBaseQuery<SbtTemplatesPage, Variables>(
    [SBT_TEMPLATES_QUERY_KEY, paramsKey],
    getSbtTemplates,
    variables,
    options
  );
};
